import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import getProp from "@insite/mobius/utilities/getProp";
import { TYPOGRAPHY } from "@store/theme/common/design";
import { transitionHoverStyles } from "@store/theme/common/mixins";
import polyfillCss from "@store/theme/common/polyfillCss";

export default {
    defaultProps: {
        cssOverrides: {
            formField: null,
            datePicker: polyfillCss`
                .react-datetime-picker {
                    color: ${getColor("text.dark")};
                    border: 2px solid ${getColor("common.border")};
                    width: 100%;

                    &__button {
                        font-size: inherit;

                    }

                    &__calendar-button {
                        &:focus {
                            span {
                                outline: none;
                                border-color: ${getProp("theme.focus.color", "#09f")};
                                border-style: ${getProp("theme.focus.style", "solid")};
                                border-width: ${getProp("theme.focus.width", "2px")};
                            }
                        }
                    }

                    &__inputGroup {
                        overflow: hidden;
                        white-space: nowrap;
                        padding: 7px 15px;

                        &__divider {
                            padding: 0 1px;
                        }

                        &__input {
                            padding-right: 0;
                            padding-left: 0;
                        }
                    }
                }

                .react-calendar {
                    padding: 0.5em;
                    box-shadow: ${getProp("theme.shadows.small")};

                    button {
                        &:enabled {
                            &:hover:not(:disabled), &:focus:not(:disabled) {
                                background-color: ${getColor("common.accent")};
                            }
                        }

                        &:disabled {
                            cursor: default;
                        }
                    }

                    &__navigation {
                        button {
                            margin: 0;
                            &:disabled {
                                opacity: 0.1;
                            }
                        }

                    }

                    &__month-view {
                        &__days {
                            &__day {
                                border-radius: 0;
                            }
                        }
                    }

                    &__tile {
                        &--hasActive:enabled:not(:disabled):not(.react-calendar__month-view__days__day--neighboringMonth),
                        &--active:enabled:not(:disabled):not(.react-calendar__month-view__days__day--neighboringMonth) {
                            background-color: ${getColor("primary")};
                            color: ${getContrastColor("primary")};
                            font-weight: ${TYPOGRAPHY.weight.bold};

                            &:hover, &:focus {
                                background-color: ${getColor("primary")};
                                color: ${getContrastColor("primary")};
                                font-weight: ${TYPOGRAPHY.weight.bold};
                            }
                        }
                        &--now {
                            color: ${getColor("primary")};
                            font-weight: ${TYPOGRAPHY.weight.bold};
                        }
                    }
                }
            `,
        },
        calendarIconProps: {
            color: "common.background",
            css: polyfillCss`
                width: 45px !important;
                height: calc(100% + 4px) !important;
                justify-content: center;
                border-radius: 0 !important;
                margin-top: -2px;
                margin-right: -12px;
                background-color: ${getColor("secondary")} !important;
                color: ${getColor("common.background")};
                ${transitionHoverStyles("background-color, color")}
                
                &:hover {
                    background-color: ${getColor("secondary.light")} !important;
                }

                svg {
                    width: 16px;
                    height: 16px;
                }
            `,
        },
        clearIconProps: {
            color: null,
            src: "X",
            css: polyfillCss`
                padding-right: 4px !important;
                padding-left: 4px !important;
                border-radius: 0 !important;
                margin-right: 10px;
                width: 24px !important;
                color: ${getColor("text.accent")};
                ${transitionHoverStyles("color")}

                &:hover {
                    color: ${getColor("text.main")};
                }
            `,
        },
    },
};
